import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetChatsAction } from '../../actions/chats/get-chats-action';
import { GetChatsSuccessAction } from '../../actions/chats/get-chats-success-action';
import { GetChatsErrorAction } from '../../actions/chats/get-chats-error-action';

@Injectable()
export class GetChatsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetChatsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetChatsAction.type),
      mergeMap(action => {
        const getChatsAction = <GetChatsAction>action;
        return this.api.getChats(getChatsAction.bijbEvent, getChatsAction.horizon).then(chats => {
          return new GetChatsSuccessAction(chats);
        }, error => {
          return new GetChatsErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
